module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 edit-profile"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !this.editable
    }
  }, [_c('div', [_c('label', {
    staticClass: "my-2",
    attrs: {
      "for": 'form-rfid'
    }
  }, [_vm._v("Kod RFID:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rfid),
      expression: "rfid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": 'rfid',
      "id": 'form-rfid'
    },
    domProps: {
      "value": (_vm.rfid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rfid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "my-2",
    attrs: {
      "for": 'form-color'
    }
  }, [_vm._v("Kolor:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "color",
      "name": 'color',
      "id": 'form-color'
    },
    domProps: {
      "value": (_vm.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.color = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "my-2 mr-2",
    attrs: {
      "for": 'form-reversed'
    }
  }, [_vm._v("Odwróć kolor tekstu:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reversed),
      expression: "reversed"
    }],
    attrs: {
      "type": "checkbox",
      "name": 'reversed',
      "id": 'form-reversed'
    },
    domProps: {
      "checked": Array.isArray(_vm.reversed) ? _vm._i(_vm.reversed, null) > -1 : (_vm.reversed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reversed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reversed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reversed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reversed = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "edit-profile__action-btns float-right"
  }, [(this.editable) ? _c('button', {
    staticClass: "btn btn-grey m-r-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadProfile()
      }
    }
  }, [_vm._v("Anuluj\n                    ")]) : _vm._e(), _vm._v(" "), (this.editable) ? _c('button', {
    staticClass: "btn btn-orange",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zapisz")]) : _vm._e()])]), _vm._v(" "), (!this.editable) ? _c('button', {
    staticClass: "btn btn-blue edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("Edytuj")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "show-label"
  }, [_c('span', [_vm._v("Podgląd etykiety:")]), _vm._v(" "), _c('span', {
    style: ({
      'border-color': this.color,
      'color': _vm.textColor
    })
  }, [_vm._v(_vm._s(_vm.username))])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-md-12 section-title"
  }, [_c('h2', [_vm._v("Edycja profilu")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa32e7b8!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/EditProfile.vue
// module id = 1108
// module chunks = 0